export const CAREERS_LINK = 'https://join.com/companies/evidencehunt';
